import GestantesPuerperasIcon from '@/components/icons/IndicadoresAps/eSFeAP/GestantesPuerperas.vue'

export default {
  value: 'c3',
  label: 'Gestantes puérperas',
  iconType: 'component',
  iconComponent: GestantesPuerperasIcon,
  buscaAtiva: {
    a: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a 1ª consulta de pré-natal (prazo: até a 12ª semana de gestação).'
        : 'Registrar a 1ª consulta de pré-natal (prazo: até a 12ª semana de gestação).',
    b: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a consulta de pré-natal (em atraso).'
        : 'Registrar a consulta de pré-natal (em atraso).',
    c: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para aferir e registrar a pressão arterial (em atraso).'
        : 'Aferir e registrar a pressão arterial (em atraso).',
    d: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para aferir e registrar peso e altura (em atraso).'
        : 'Aferir e registrar peso e altura (em atraso).',
    e: 'Acionar o Agente de Saúde para visita domiciliar (em atraso).',
    f: 'Encaminhar para a vacina dTpa (a partir da 20ª semana).',
    g: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para solicitar ou avaliar os testes de sífilis, HIV e hepatites B e C (1º trimestre).'
        : 'Solicitar ou avaliar os testes de sífilis, HIV e hepatites B e C (1º trimestre).',
    h: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para solicitar ou avaliar os testes de sífilis e HIV (3º trimestre).'
        : 'Solicitar ou avaliar os testes de sífilis e HIV (3º trimestre).',
    i: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a consulta de puerpério (presencial ou remota em atraso).'
        : 'Registrar a consulta de puerpério (presencial ou remota em atraso).',
    j: 'Acionar o Agente de Saúde para visita domiciliar de puerpério.',
    k: ({ perfilEsfOuEmulti, perfilOdontologo }) =>
      perfilEsfOuEmulti
        ? 'Encaminhar para a avaliação odontológica (uma por gestação).'
        : perfilOdontologo
        ? 'Realizar e registrar a avaliação odontológica (uma por gestação).'
        : 'Encaminhar ou realizar a avaliação odontológica (uma por gestação).',
  },
}
